
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","version":"1.1","id":"play-white-Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 30 30","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"play-white-st0",attrs:{"id":"play-white-a","fill":"#FFF","d":"M0 0v30l30-15L0 0z"}})])
          )
        }
      }
    